// extracted by mini-css-extract-plugin
module.exports = {"mouseEvents":"Point--mouseEvents--1h8RC","innerPoint":"Point--innerPoint--28M4n","outerPoint":"Point--outerPoint--gC8Xz"};